import React, {  Component } from 'react';

export default class ModalAddSerialNumberOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			originalSerialNumbers: [],
			serialNumber: [],
            selectAll: false,
            userEnteredSerialNumber: '',
            userEnteredSerialNumberError: '',
        };
        this.handleSelectAll = this.handleSelectAll.bind(this);
    }
    onChangeSerialNumber(event) {
        this.setState({
            userEnteredSerialNumber: event.target.value.toUpperCase(),
            userEnteredSerialNumberError: '',
        });
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog("ModalAddSerialNumberOverlayDialog", false);
    }
	componentWillMount() {
        const originalSerialNumbers = this.props.originalSerialNumbers ? this.props.originalSerialNumbers.split(/[ ,]+/) : [];
        const propSerialNumbers = this.props.serialNumber ? this.props.serialNumber.split(" ") : [];
        let serialNumber = propSerialNumbers.filter(item => originalSerialNumbers.indexOf(item) !== -1);
        let userEnteredSerialNumber = propSerialNumbers.filter(item => originalSerialNumbers.indexOf(item) === -1);
		this.setState({
			serialNumber,
            userEnteredSerialNumber: userEnteredSerialNumber.join(", "),
			originalSerialNumbers
		})
	}
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
	handleChangeSerialNumber(value, event) {
		const checked = event.target.checked;
		const self = this;
		const serialNumber = self.state.serialNumber;
		let updatedSerialNumbers = [];
		if(checked) {
			updatedSerialNumbers = self.state.serialNumber;
			updatedSerialNumbers.push(value);
		} else {
			updatedSerialNumbers = [];
			serialNumber.forEach(item => {
				if(item !== value) {
					updatedSerialNumbers.push(item);
				}
			});
		}
		self.setState({
			serialNumber: updatedSerialNumbers,
            selectAll: checked ? self.state.selectAll : false
		});
	}
	handleSave(event) {
		event.preventDefault();
		const self = this;
        let formError = false;
        let {
            userEnteredSerialNumber,
            userEnteredSerialNumberError
        } = self.state;
        let serialNumberList = [];
        if (userEnteredSerialNumber && userEnteredSerialNumber.trim()) {
            serialNumberList = userEnteredSerialNumber.split(',').map(item => item.trim());
            // check if all serialnumber length is 8 character
            if (serialNumberList.find(item => item.length !== 8)) {
                formError = true;
                userEnteredSerialNumberError = 'Should have 2 characters and 6 numbers';
            } else {
                const numericRegex = /^[0-9]*$/;
                const alphabetRegex = /^[A-Z]*$/;
                serialNumberList.forEach(item => {
                    const first2Character = item.substring(0, 2);
                    const last6Character = item.substring(2);
                    if (!alphabetRegex.test(first2Character) || !numericRegex.test(last6Character)) {
                        formError = true;
                        userEnteredSerialNumberError = 'Should have 2 characters and 6 numbers';
                    }
                });
            }
        }
        self.setState({
            userEnteredSerialNumberError
        }, () => {
            if (!formError) {
                const serialNumbers = self.state.serialNumber.concat(serialNumberList);
        		self.props.handleCallbackAfterSelect(serialNumbers.join(" "));
            }
        });
	}
    handleSelectAll(event) {
        const self = this;
        const checked = event.target.checked;
        self.setState({
			serialNumber: checked ? self.state.originalSerialNumbers : [],
            selectAll: checked
		});
    }
    render() {
		const self = this;
		const { originalSerialNumbers, userEnteredSerialNumber, userEnteredSerialNumberError } = self.state;
        const sortedOriginalSerialNumbers = originalSerialNumbers.sort();
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="modalAddSerialNumber">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Add Serial Number</h2>
                    <p>Select Serial Number(s) of the product you want to return:</p>
                    <input type="checkbox" onChange={this.handleSelectAll.bind(this)} checked={self.state.selectAll} />&nbsp;<strong>Select All</strong>
                    <div style={{height: '150px', overflow: 'auto'}}>
    					<table>
    						<tbody>
    							{sortedOriginalSerialNumbers.map((item, index) => {
    								return <tr key={index}>
    									<td>
    										<input type="checkbox" onChange={this.handleChangeSerialNumber.bind(this, item)} checked={self.state.serialNumber.indexOf(item) !== -1} />
    									</td>
    									<td>
    										<label htmlFor="serial00">{item}</label>
    									</td>
    								</tr>
    							})}
    						</tbody>
    					</table>
                    </div>
                    <br />
                    <div>
                        <strong>Serial Number:</strong> <input placeholder="2 capital and 6 numbers" type="text" name="userEnteredSerialNumber" className={userEnteredSerialNumberError ? 'error' : ''} value={userEnteredSerialNumber} onChange={this.onChangeSerialNumber.bind(this)} />
                        {userEnteredSerialNumberError && <p className="red">{userEnteredSerialNumberError}</p>}
                    </div>
					<div className="buttonContainer">
					    <a href="" className="okButton blueButton d-none d-sm-block" onClick={this.handleSave.bind(this)}>Save</a>
                        <a href="" className="okButton blueButton d-block d-sm-none fs-6" onClick={this.handleSave.bind(this)}>Save</a>
					</div>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/modalAddSerialNumberOverlayDialog.js